

export default function InputTextArea({ placeholder, validationLabel, value, name, onChange, label, disabled = false, rows }) {

    const nonValidStyle = {
        backgroundColor: "#dc35454d",
        borderBottom: "1px solid #dc3545"
    }

    const disabledStyle = {
        backgroundColor: "lightgray",
        color: "gray"
    }

    return (
        <div className="relative w-full">
            <textarea rows={rows} className={"min-h-10 placeholder:text-gray outline-none border-b border-[#504343] bg-[#f5f5f5] px-2 py-1 w-full text-md focus:bg-[#ebebeb]"} style={disabled ? disabledStyle : (validationLabel ? nonValidStyle : {})} name={name} value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} />
            <label className="absolute top-0 right-1 text-red text-xs" htmlFor={name} >{validationLabel}</label>
            <p className="text-gray text-xs">{label}</p>
        </div>
    )
}